const containers = {
    solid: [{
          size: 'lg',
          label: 'sizes.lg',
          icon: 'dry-lg.svg'
      },{
          size: 'md',
          label: 'sizes.md',
          icon: 'dry-md.svg'
      },{
          size: 'sm',
          label: 'sizes.sm',
          icon: 'dry-sm.svg'
      }
    ],
    liquid: [{
          size: 'lg',
          label: 'sizes.lg',
          icon: 'liquid-lg.svg'
      },{
          size: 'rg',
          label: 'sizes.rg',
          icon: 'liquid-rg.svg'
      }
    ],
    item: {
      size: 'md',
      label: 'sizes.item',
      icon: 'item.svg'
    },
    measurements: {
      grams: {
        sm: 120,
        md: 250,
        lg: 500
      },
      litre: {
        sm: 0.5,
        md: 1.0,
        lg: 2.5
      }
    }
}

export default containers
